import TemporaryActions from "../../prat_actions/gt/temporaryActions"

export default class TemporaryMiddleware {
    static productDetail(arr) {
        return dispatch => {
            dispatch(TemporaryActions.productDetail({product:arr}))
        }
    }

    static geoDetail(arr){
        return dispatch => {
            dispatch(TemporaryActions.geoDetail({geo: arr}))
        }
    }
}